/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CreatePlayerNoteCommand } from '../../models/create-player-note-command';
import { PlayerNoteDtoResult } from '../../models/player-note-dto-result';

export interface ApiPlayerNotesPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingTrue$Params {
      body?: CreatePlayerNoteCommand
}

export function apiPlayerNotesPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingTrue(http: HttpClient, rootUrl: string, params?: ApiPlayerNotesPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingTrue$Params, context?: HttpContext): Observable<StrictHttpResponse<PlayerNoteDtoResult>> {
  const rb = new RequestBuilder(rootUrl, apiPlayerNotesPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingTrue.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json;odata.metadata=minimal');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json;odata.metadata=none;odata.streaming=true', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PlayerNoteDtoResult>;
    })
  );
}

apiPlayerNotesPost$JsonOdataMetadataMinimal$JsonOdataMetadataNoneOdataStreamingTrue.PATH = '/api/player-notes';
